import { render, staticRenderFns } from "./BoardSchedule.vue?vue&type=template&id=525e3d09&scoped=true&"
import script from "./BoardSchedule.vue?vue&type=script&lang=js&"
export * from "./BoardSchedule.vue?vue&type=script&lang=js&"
import style0 from "./BoardSchedule.vue?vue&type=style&index=0&id=525e3d09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e3d09",
  null
  
)

export default component.exports